import { loadScript } from '../../utils/loadScript';

const ID = 'ApplePaySDK';

/**
 * @see https://developer.apple.com/documentation/applepayontheweb/loading-the-latest-version-of-apple-pay-js
 */
const SCRIPT_SRC = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

export const loadApplePaySdk = (): Promise<void> => {
    if (window.ApplePaySession) {
        return Promise.resolve();
    }

    return loadScript(ID, SCRIPT_SRC);
};
